import AppContent from './appContent/AppContent';
import AppPanel from './AppPanel';
import AppPanelCollapseSmall from './AppPanelCollapseSmall';
import BorderedFieldset from './BorderedFieldset';
import CollapseExpandButton from '../buttons/CollapseExpandButton';
import ComponentSlider from './ComponentSlider';
import DatePicker from '../inputs/DatePicker';
import DateTimeLabel from './DateTimeLabel';
import EmptyList from '../lists/EmptyList';
import EnumSelect from '../inputs/EnumSelect';
import FlagsDropdown from './FlagsDropdown';
import GroupedSelect from '../inputs/GroupedSelect';
import Icon from '../icon';
import LabelEdit from '../inputs/LabelEdit';
import Loader from '../Loading';
import LoadingButton from './LoadingButton';
import Modal from './Modal';
import Multiselect from '../inputs/multiselect';
import Number from './Number';
import PopUpMenu from './PopUpMenu';
import RealTimeClock from './RealTimeClock';
import Select from '../inputs/Select';
import Switch from './Switch';
import Table from '../table';
import TimeInput from '../inputs/Time';
import ValidationTooltip from './ValidationTooltip';
import SearchInput from './SearchInput';
import Sidebar from '../sidebar/Sidebar';
import NumberInput from '../inputs/NumberInput';

export default {
  install(Vue) {
    Vue.component('app-content', AppContent);
    Vue.component('app-panel', AppPanel);
    Vue.component('app-panel-collapse-small', AppPanelCollapseSmall);
    Vue.component('date-time-label', DateTimeLabel);
    Vue.component('pop-up-menu', PopUpMenu);
    Vue.component('real-time-clock', RealTimeClock);
    Vue.component('s-collapse-expand-button', CollapseExpandButton);
    Vue.component('s-component-slider', ComponentSlider);
    Vue.component('s-empty-list', EmptyList);
    Vue.component('s-enum-select', EnumSelect);
    Vue.component('s-fieldset', BorderedFieldset);
    Vue.component('s-flags-dropdown', FlagsDropdown);
    Vue.component('s-grouped-select', GroupedSelect);
    Vue.component('s-icon', Icon);
    Vue.component('s-input-date-picker', DatePicker);
    Vue.component('s-input-label-edit', LabelEdit);
    Vue.component('s-input-time', TimeInput);
    Vue.component('s-loader', Loader);
    Vue.component('s-loading-button', LoadingButton);
    Vue.component('s-modal', Modal);
    Vue.component('s-multiselect', Multiselect);
    Vue.component('s-number', Number);
    Vue.component('s-search-input', SearchInput);
    Vue.component('s-select', Select);
    Vue.component('s-switch', Switch);
    Vue.component('s-table', Table);
    Vue.component('s-validation-tooltip', ValidationTooltip);
    Vue.component('s-sidebar', Sidebar);
    Vue.component('s-number-input', NumberInput);
  },
};
